<template>
  <div
    class="c-app app header-fixed sidebar-fixed sidebar-lg-show"
    :key="`locale-${$i18n.locale}`"
  >
    <ThePageHeader v-if="IS_MZ_BRANDING"/>
    <TheHeader v-else/>
    <TheSidebar/>
    <CWrapper>
      <TheToast />
      <div class="c-body">
        <RaBreadcrumbRouter />
        <main style="margin: 0 24px">
          <router-view v-slot="{ Component, route }">
            <transition name="fade" mode="out-in">
              <component :is="Component" :key="$route.path"/>
            </transition>
          </router-view>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheFooter from './TheFooter'
import ThePageHeader from './ThePageHeader'
import TheHeader from './TheHeader'
import TheToast from './TheToast'
import { IS_MZ_BRANDING } from '@/constants/config';
import { ClosingFileService } from "@/services/closing_file";

export default {
  name: 'TheContainer',
  data() {
    return {
      IS_MZ_BRANDING,
    };
  },
  async mounted() {
    await this.fetchCommitQuarter()
  },
  watch: {
    async "$route.params.quarter_name"() {
      await this.fetchCommitQuarter()
    }
  },
  methods: {
    async fetchCommitQuarter() {
      const quarter_name = this.$route?.params?.quarter_name
      if (!quarter_name) return
      const quarter = await ClosingFileService.getQuarter(quarter_name)
      this.$store.commit("set", ["quarter", quarter]);
      this.$store.commit("set", ["quarter_name", quarter.display_name]);
    }
  },
  components: {
    TheSidebar,
    TheFooter,
    ThePageHeader,
    TheHeader,
    TheToast,
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.breadcrumb-wrapper {
  position: sticky;
  top: 0;
  z-index: 1000;
}
</style>
